/* eslint-disable */
import { useState } from "react";
import { useEffect } from "react";
import ReactPlayer from 'react-player/lazy';
import FileDownloadIcon from "components/FileDownloadIcon"
import PdfViewer from "components/pdf/PdfViewer"
import { fileAccepts } from 'data/data';
import { Box, CardContent, CircularProgress } from "@mui/material";
import MainCard from "./MainCard";
import PdfLayer from "./layer/PdfLayer";

const FileViewer = ({file, printRef, isLayer=false}) => {

    const [accept, setAccept] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    
    useEffect(()=>{
        if (file) {
            const extension = file.originFile.substring(file.originFile.lastIndexOf(".")).toLowerCase();
            setAccept(fileAccepts.filter(acc => acc.extension.indexOf(extension) !== -1)[0]);
            setFileUrl(window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/download/"+file.id);
        }
    },[file]);

    if (!isLayer) {
        if (file && fileUrl && accept && accept.code === 'I') {
            return (
                <div ref={printRef} style={{position:"relative", width:"100%",/* height:"500px",*/ maxHeight:"500px", overflow:"auto", textAlign:"center", padding:"10px"}}>
                    <img src={fileUrl} style={{maxWidth:"100%"}}/>
                </div>
            )
        }

        if (file && accept && accept.code === 'M') {
            return (
                <div ref={printRef} className='player-wrapper' style={{width:'100%'}}>
                    <ReactPlayer
                        className='react-player'
                        controls
                        url={fileUrl}
                        width='100%'
                        height='100%'
                        playing={true}
                        loop={true}
                    />
                </div>
            )
        }
    }

    if (file && accept && accept.code === 'P') {
        return (
        <MainCard title="" content={false}>
            <CardContent style={{height:"100%"}}>
                {isLayer ? 
                <PdfLayer file={file} isLayer={isLayer} />
                :
                <PdfViewer fileUrl={fileUrl} printRef={printRef} />
                }
            </CardContent>
        </MainCard>
        )
    }

    // if (file && accept && accept.code === 'E') {
    if (file) {
        return (
            <div ref={printRef} style={{position:"relative", width:"100%",/* height:"500px",*/ maxHeight:"500px", overflow:"auto", textAlign:"center", padding:"10px"}}>
            {/* <div ref={printRef} style={{position:"relative", width:"100%", height:"500px"}}>
                <div style={{ top:"45%", left:"50%", position:"absolute"}}> */}
                    <FileDownloadIcon file={file} iconSize="large" />
                    {/* <div style={{marginLeft:"-50%"}}>{file.originFile}</div> */}
                {/* </div> */}
            </div>
        )
    }
}

export default FileViewer;